import React, { useState, useEffect, useRef } from "react";
import "./Chatbot.css";
import logoTraffix from "../assets/logo-traffix.png";
const qa = {
  // Saluti e introduzione
  ciao: "Ciao! 👋 Sono l'assistente virtuale di Traffix. Come posso aiutarti oggi?",
  buongiorno:
    "Buongiorno! ☀ Benvenuto nel mondo di Traffix. Cosa vorresti sapere?",
  buonasera:
    "Buonasera! 🌅 Sono qui per rispondere alle tue domande su Traffix.",
  aiuto:
    "Certamente! Puoi chiedermi informazioni su moduli, prezzi, demo, contatti o funzionalità di Traffix. Cosa ti interessa di più?",

  // Traffix generale
  "cos'è traffix":
    "Traffix è una suite modulare avanzata per la gestione e l'ottimizzazione intelligente della mobilità urbana, sviluppata da Exis Mobility (Exis Engineering Solutions).",
  "come funziona traffix":
    "Traffix utilizza algoritmi avanzati e dispositivi proprietari per la pianificazione e la gestione del il traffico live attraverso diversi moduli specializzati e complementari.",
  "vantaggi traffix":
    "I principali vantaggi sono: moduli orientati a problemi specifici, nati da esigenze reali, utilizzabili tramite interfacce user-friendly.",
  "caratteristiche traffix":
    "Traffix offre modularità, scalabilità, interfacce intuitive, analisi mirate, integrazione IoT e customizzazione.",

  // Moduli specifici
  "moduli traffix":
    "I moduli principali sono: SemaFix (piani semaforici), SignalFix (censimento segnaletica), SyncFix (sincronizzazione e onda verde), SimFix (analisi di simulazioni), MysteryX (analisi indagini TPL) e Be-Twin | Raise (digital twin di mobilità).",
  semafix:
    "SemaFix è il modulo per la progettazione e la gestione dei cicli semafori (veicolari e pedonali) con ottimizzazione automatica dei tempi basata sui flussi di traffico in tempo reale.",
  signalfix:
    "SignalFix rileva e censisce la segnaletica stradale verticale, tramite tecnologia mobile proprietaria e permette la gestione di editing e manutenzione ",
  syncfix:
    "SyncFix sincronizza le fasi semaforiche per creare onde verdi e ottimizzare i flussi urbani.",
  simfix:
    "SimFix è il visualizzatore avanzato che permette di confrontare what if scenario simulati prima dell'implementazione reale.",
  mysteryx:
    "MysteryX confronta i risultati di indagini di Tpl (o custom) tramite modelli gerarchizzati e benchmark anonimi",
  "be-twin":
    "Be-Twin è il dimostratore del progetto Be-Twin; gestisce live in un unico ambiente metriche di mobilità, geometrie 3d navigabili, esternalità, anomaly detection",

  // Prezzi e commerciale
  prezzi:
    "I prezzi variano in base ai moduli scelti e alle dimensioni dell'implementazione. Contatta il nostro team commerciale per un preventivo personalizzato.",
  costi:
    "Per informazioni dettagliate sui costi, ti invitiamo a contattarci e richiedere una demo gratuita dove potrai valutare le soluzioni più adatte alle tue esigenze con il supporto del team tecnico.",
  preventivo:
    "Puoi richiedere un preventivo gratuito contattandoci a info@exisengsol.it o cliccando su 'Richiedi demo' nella sezione moduli.",
  licenze:
    "Offriamo diverse tipologie di licenze: per singolo incrocio, per area urbana o per intere città. Contattaci per i dettagli.",

  // Demo e trial
  demo: "Puoi richiedere una demo gratuita cliccando sul pulsante 'Richiedi demo' presente in ogni scheda modulo o contattandoci direttamente.",
  "richiedi demo":
    "Perfetto! Puoi richiedere la tua demo gratuita visitando la sezione moduli del sito o scrivendoci a info@exisengsol.it.",
  "prova gratuita":
    "Offriamo demo personalizzate per mostrarti le potenzialità di Traffix. Contattaci per organizzare la tua sessione di prova.",
  test: "Puoi testare Traffix attraverso le nostre demo interattive. Contatta il team per programmare una sessione personalizzata.",

  // Contatti e supporto
  contatti:
    "📧 Email: francesco.rebora@exisengsol.it | 🔧 Supporto: info@exisengsol.it  | Oppure usa il pulsante 'Richiedi demo' sul sito.",
  email:
    "Le nostre email principali sono info@exisengsol.it per informazioni generali e francesco.rebora@exisengsol.it per il supporto tecnico/commerciale.",
  telefono:
    "Per il supporto telefonico, ti invitiamo a contattarci via email e ti forniremo tutti i recapiti necessari.",
  supporto:
    "Il nostro team di supporto è disponibile a info@exisengsol.it per assistenza tecnica e risoluzione problemi.",
  assistenza:
    "Offriamo assistenza completa: supporto tecnico, formazione utenti, aggiornamenti e manutenzione. Contatta info@exisengsol.it",

  // Azienda
  "chi siete":
    "Siamo Exis Mobility (Exis), una PMI ligure nata nel 2016 como spin-off dell'Università di Genova. Riuniamo docenti, ricercatori e ingegneri con oltre 20 anni di esperienza e trasformiamo la ricerca scientifica in soluzioni concrete per la mobilità urbana, portuale e intermodale. Offriamo consulenza tecnica, sviluppo software, modellazione di scenari complessi e progettazione di sistemi di trasporto intelligenti (ITS) e strumenti digitali di supporto alle decisioni (DSS). Grazie a intelligenza artificiale, machine learning e simulazioni avanzate affrontiamo le sfide della mobilità, della logistica, della sicurezza stradale e della pianificazione sostenibile. Partecipiamo a progetti nazionali ed europei e facciamo parte della rete d'impresa ITS di Genova. Il nostro team multidisciplinare e i partner consolidati ci permettono di offrire soluzioni innovative, dal laboratorio di ricerca fino all'implementazione operativa.",
  "exis mobility":
    "Exis Mobility è il nuovo nome della storica società Exis Engineering Solutions; Offre consulenza tecnica, sviluppo software, modellazione di scenari complessi e progettazione di sistemi di trasporto intelligenti (ITS) e strumenti digitali di supporto alle decisioni (DSS). Grazie all'uso di intelligenza artificiale, machine learning e simulazioni avanzate, EXIS affronta sfide legate a mobilità, logistica, sicurezza stradale e pianificazione sostenibile. Partecipa a progetti nazionali ed europei ed è parte della rete d'impresa ITS di Genova.",
  missione:
    "La nostra missione è trasformare la ricerca scientifica in soluzioni innovative e concrete per la mobilità e la logistica, contribuendo a rendere i sistemi di trasporto più intelligenti, sicuri e sostenibili.",
  servizi:
    "Offriamo servizi di raccolta e analisi dei dati di traffico da fonti satellitari, GPS, IoT e sensori. Progettiamo sistemi di supporto alle decisioni (DSS) per la gestione intelligente della mobilità. Realizziamo modellazioni e simulazioni di reti stradali e logistiche, sia a livello micro che macro. Sviluppiamo soluzioni di Smart Mobility e Smart City basate su algoritmi proprietari e processi data-driven. Applichiamo Intelligenza Artificiale e Machine Learning per ottimizzare processi e prestazioni. Progettiamo e sviluppiamo soluzioni custom per la mobilità e i contesti connessi.",

  // Tecnico e implementazione
  installazione:
    "L'installazione di Traffix viene gestita dal nostro team tecnico specializzato con supporto completo durante tutto il processo.",
  integrazione:
    "Traffix si integra facilmente ad ogni infrastruttura esistente grazie alle sue API aperte e alla modularità del sistema.",
  requisiti:
    "I requisiti dipendono dai moduli scelti. Il nostro team tecnico valuterà la tua infrastruttura per un'implementazione ottimale.",
  compatibilità:
    "Traffix nasce per essere compatibile con sistemi esistenti e supporta protocolli di comunicazione standard.",
  "moduli custom":
    "Vuoi sviluppare con noi il tuo modulo? Parliamone, contattaci!",

  // Accesso e registrazione
  "come accedere":
    "Puoi accedere alla piattaforma cliccando su 'Accedi / Registrati' in alto a destra del sito web.",
  registrazione:
    "Per registrarti, clicca su 'Accedi / Registrati' e segui la procedura guidata, oppure contattaci se avessi problemi.",
  login:
    "Effettua il login dalla homepage del sito utilizzando le tue credenziali. Hai dimenticato la password? Usa il recupero credenziali.",
  password:
    "Se hai dimenticato la password, usa la funzione 'Password dimenticata' nella pagina di login o contatta il supporto.",

  // Lingue e localizzazione
  lingue:
    "Traffix è disponibile in italiano e inglese, con possibilità di localizzazione in altre lingue su richiesta.",
  multilingue: "Sì, la piattaforma supporta la lingua italiana ed inglese.",

  // Smart Cities e sostenibilità
  "smart city":
    "Traffix è perfettamente integrato nell'ecosistema Smart City, contribuendo alla sostenibilità e all'efficienza urbana.",
  sostenibilità:
    "Ottimizzando i flussi di traffico, Traffix riduce significativamente le emissioni CO2 e migliora la qualità dell'aria urbana.",
  ambiente:
    "I nostri sistemi contribuiscono alla sostenibilità ambientale riducendo code, tempi di percorrenza e conseguentemente le emissioni.",

  // Casi d'uso e settori
  "casi d'uso":
    "Traffix è ideale per la gestione del traffico di qualsiasi area, facci sapere di cosa hai bisogno.",
  settori:
    "Serviamo Pubbliche amministrazioni, aziende private, gestori di infrastrutture, enti territoriali e grandi player internazionali.",
  riferimenti:
    "Abbiamo implementato soluzioni in diverse realtà italiane ed europee. Contattaci per casi di studio dettagliati.",

  // Aggiornamenti e futuro
  aggiornamenti:
    "Rilasciamo aggiornamenti regolari con nuove funzionalità, miglioramenti delle performance e patch di sicurezza.",
  roadmap:
    "La nostra roadmap include AI più avanzata, maggiore integrazione IoT e nuovi moduli specializzati. Contattaci per dettagli.",
  novità:
    "Rimani aggiornato sulle novità seguendo i nostri canali, teniamoci in contatto!.",
};

const suggestions = [
  "casi d'uso",
  "moduli custom",
  "demo",
  "chi siete",
  "Cos'è SemaFix?",
  "moduli traffix",
];

function Chatbot() {
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "👋 Ciao! Sono l'assistente virtuale di **Traffix**.\n\n🚦 Posso aiutarti con informazioni su moduli, prezzi, demo e molto altro!\n\nProva a scrivere una domanda o clicca su un suggerimento qui sotto ⬇️",
    },
  ]);
  const [input, setInput] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const findBestMatch = (userInput) => {
    const input = userInput.toLowerCase().trim();

    // Exact match
    if (qa[input]) return qa[input];

    // Partial match
    for (const [key, value] of Object.entries(qa)) {
      if (input.includes(key) || key.includes(input)) {
        return value;
      }
    }

    // Keyword matching
    const keywords = {
      moduli: qa["moduli traffix"],
      demo: qa["demo"],
      prezzo: qa["prezzi"],
      costo: qa["costi"],
      contatto: qa["contatti"],
      supporto: qa["supporto"],
      accesso: qa["come accedere"],
      login: qa["login"],
      registra: qa["registrazione"],
      smart: qa["smart city"],
      ambiente: qa["ambiente"],
      sostenibile: qa["sostenibilità"],
    };

    for (const [keyword, response] of Object.entries(keywords)) {
      if (input.includes(keyword)) return response;
    }

    return "🤔 Non ho trovato una risposta specifica, ma posso aiutarti con:\n\n• Informazioni sui moduli Traffix\n• Richiesta demo e prezzi\n• Contatti e supporto tecnico\n• Caratteristiche e funzionalità\n\nProva a riformulare la domanda o usa i suggerimenti! 💡";
  };

  const handleSend = () => {
    if (!input.trim()) return;

    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");
    setIsTyping(true);

    // Simulate typing delay
    setTimeout(() => {
      const botAnswer = findBestMatch(input);
      setMessages((prev) => [...prev, { sender: "bot", text: botAnswer }]);
      setIsTyping(false);
    }, 1000);
  };

  const handleSuggestionClick = (suggestion) => {
    setInput(suggestion);
  };

  const formatMessage = (text) => {
    // Simple markdown-like formatting
    return text
      .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
      .replace(/\*(.*?)\*/g, "<em>$1</em>")
      .split("\n")
      .map((line, i) => (
        <React.Fragment key={i}>
          {i > 0 && <br />}
          <span dangerouslySetInnerHTML={{ __html: line }} />
        </React.Fragment>
      ));
  };

  return (
    <div className="chatbot-wrapper">
      {/* Floating button */}
      <button
        className="chatbot-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Apri chatbot Traffix"
      >
        {isOpen ? (
          "✖"
        ) : (
          <img src={logoTraffix} alt="Traffix" className="btn-logo" />
        )}
      </button>

      {/* Notification badge */}
      {!isOpen && (
        <div className="notification-badge">
          <span>Hai domande su Traffix?</span>
        </div>
      )}

      {/* Chatbox */}
      {isOpen && (
        <div className="chatbot-container">
          <div className="chatbot-header">
            <div className="header-info">
              <div className="bot-avatar">
                {" "}
                <img src={logoTraffix} alt="Traffix" className="btn-logo" />
              </div>
              <div>
                <div className="bot-name">Traffix Assistant</div>
                <div className="bot-status">Online</div>
              </div>
            </div>
            <button
              className="chatbot-close"
              onClick={() => setIsOpen(false)}
              aria-label="Chiudi chat"
            >
              ✖
            </button>
          </div>

          <div className="chatbot-messages">
            {messages.map((msg, i) => (
              <div key={i} className={`chat-msg ${msg.sender}`}>
                {msg.sender === "bot" && (
                  <div className="msg-avatar">
                    {" "}
                    <img src={logoTraffix} alt="Traffix" className="btn-logo" />
                  </div>
                )}
                <div className="msg-content">
                  {formatMessage(msg.text)}
                  <div className="msg-time">
                    {new Date().toLocaleTimeString("it-IT", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </div>
                </div>
              </div>
            ))}

            {isTyping && (
              <div className="chat-msg bot">
                <div className="msg-avatar">🤖</div>
                <div className="msg-content typing">
                  <div className="typing-indicator">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            )}

            {messages.length === 1 && (
              <div className="suggestions-container">
                <div className="suggestions-title">💡 Domande frequenti:</div>
                <div className="suggestions">
                  {suggestions.map((suggestion, i) => (
                    <button
                      key={i}
                      className="suggestion-btn"
                      onClick={() => handleSuggestionClick(suggestion)}
                    >
                      {suggestion}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div ref={messagesEndRef} />
          </div>

          <div className="chatbot-input">
            <input
              type="text"
              placeholder="Scrivi la tua domanda..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSend()}
              disabled={isTyping}
            />
            <button
              onClick={handleSend}
              disabled={isTyping || !input.trim()}
              aria-label="Invia messaggio"
            >
              ➤
            </button>
          </div>

          <div className="chatbot-footer">
            <span>Powered by Traffix AI</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default Chatbot;
